import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
/**
 * {
 * path:xxx // 主分类
 * component: Layout, // 缓存优化/按需加载
 * alwaysShow: true, // 只有一条时依旧为下拉栏
 * hidden: true // (默认 false) // 不显示该路由
 * meta:   { // 主分类模块设置
 * title: '账号管理', // 主页面名称
 * icon: 'el-icon-s-custom', // 主分类图标
 * breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
 * roles: ['admin', 'editor'] // 身份权限设置,也可以设置在子页面上
 *    },
 * }
 * // 子页面模块
 * children: [
 * {
 * name: 'accountList', // 用于页面缓存/且必须为单独值
 * path: '/accountList', // 页面路由  二种写法，相对写法：不以/开头，它的值是相对于父级的path, 绝对写法 它的值就是相应的跳转path
 * component: () => import('@/views/account/accountList'), // 按需加载 指向页面
 *  meta: {
 *    title: '账号列表', // 子页面标题
 *    noCache: true, // 不会被 <keep-alive> 缓存
 *    breadcrumb: false //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
 *        }
 *     },
 *   ]
 * }
 */
/* Layout */
import Layout from "@/layout";
//  动态路由
export const asyncRoutes = [
  {
    path: "projectResearch",
    component: Layout,
    meta: {
      title: "项目",
      icon: "el-icon-s-custom",
      breadcrumb: false,
    },
    children: [
      {
        name: "allProject",
        path: "/allProject",
        component: () => import("@/views/projectResearch/allProject"),
        meta: { title: "全部项目" },
      },
      {
        name: "addProject",
        path: "/addProject",
        component: () => import("@/views/projectResearch/setProject"),
        meta: { title: "新增项目" },
      },
      {
        name: "editProject",
        path: "/editProject/:id",
        component: () => import("@/views/projectResearch/setProject"),
        meta: { title: "编辑项目" },
      },
      {
        name: "copyProject",
        path: "/copyProject/:id/:copy",
        component: () => import("@/views/projectResearch/setProject"),
        meta: { title: "复制项目" },
      },
    ],
  },

  {
    // ------------------------------------------------------
    path: "inspection",
    component: Layout,
    meta: {
      title: "项目绘检",
      icon: "el-icon-s-operation",
      breadcrumb: false, // 是否显示面包屑
      noCache: true, // 是否缓存
    },
    children: [
      {
        name: "inspectionLite",
        path: "/inspectionLite/:project_id/:project_name/:detectionModule",
        component: () => import("@/views/inspectionLite/index"),
        meta: { title: "项目绘检", noCache: true },
      },
    ],
  },
  // 项目列表
  {
    path: "projectList",
    component: Layout,
    meta: {
      title: "项目列表",
      icon: "el-icon-s-custom",
      breadcrumb: false,
    },
    children: [
      {
        name: "projectList",
        path: "/mobileViews/projectList",
        component: () => import("@/views/mobileViews/projectList/index"),
        meta: { title: "项目列表" },
      },
    ],
  },
  {
    path: "systemManagement",
    component: Layout,
    meta: {
      title: "系统管理",
      icon: "el-icon-s-custom",
      breadcrumb: false,
    },
    children: [
      {
        name: "department",
        path: "/department",
        component: () => import("@/views/systemManagement/department"),
        meta: { title: "部门" },
      },
      {
        name: "staff",
        path: "/staff",
        component: () => import("@/views/systemManagement/staff"),
        meta: { title: "员工" },
      },
      {
        name: "standardManagement",
        path: "/standardManagement",
        component: () => import("@/views/systemManagement/standardManagement"),
        meta: { title: "规范管理" },
      },
      {
        name: "deviceManagement",
        path: "/deviceManagement",
        component: () => import("@/views/systemManagement/deviceManagement"),
        meta: { title: "设备管理" },
      },
    ],
  },
  {
    name: "qrcode",
    path: "/qrcode",
    component: () => import("@/components/QRCode/index.vue"),
    meta: { title: "扫码" },
  },
  {
    name: "camera",
    path: "/camera",
    component: () => import("@/views/photograph/camera"),
    meta: { title: "拍照" },
  },
  {
    name: "qrcodeCrack",
    path: "/qrcodeCrack",
    component: () => import("@/views/qrcode/qrcode1"),
    meta: { title: "拍照" },
  },
  {
    name: "scoreboard",
    path: "/scoreboard",
    component: () => import("@/views/scoreboard/index"),
    meta: { title: "记录板" },
  },
  {
    name: "crack",
    path: "/crack",
    component: () => import("@/views/crack/index"),
    meta: { title: "绘制裂缝" },
  },
  { path: "*", redirect: "/404", hidden: true },
];

// 静态路由
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/android-report/:project_id",
    component: () =>
      import("@/views/inspectionLite/viewLite/hi_report/ReportAndroid.vue"),
    hidden: true,
    meta: {
      title: "排查报告",
      noCache: true,
    },
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        name: "home",
        path: "/",
        component: () => import("@/views/home/homeIndex"),
        meta: {
          title: "首页",
          icon: "el-icon-s-home",
        },
      },
      {
        name: "pageElement",
        path: "/pageElement",
        component: () => import("@/views/home/pageElement"),
        meta: {
          title: "封装组件调用测试",
          icon: "el-icon-s-home",
        },
      },
    ],
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true, // 是否显示
  },

  // {
  //   // ------------------------------------------------------
  //   name: "detection",
  //   path: "/detection/:project_id/:project_name/:detectionModule",
  //   component: () => import("@/views/detection/index"),
  //   meta: {
  //     title: "检测页面",
  //     icon: "el-icon-s-operation",
  //     breadcrumb: false,
  //   },
  // },

  {
    path: "calculationDetails",
    component: Layout,
    meta: {
      title: "计算详情",
      breadcrumb: false,
    },
    children: [
      {
        name: "brickCalculate",
        path: "/brickCalculate/:project_id",
        component: () => import("@/views/calculationDetails/brickCalculate"),
        meta: { title: "砖回弹计算详情" },
      },
      {
        name: "mortarCalculate",
        path: "/mortarCalculate/:project_id/:type",
        component: () => import("@/views/calculationDetails/mortarCalculate"),
        meta: { title: "砂浆回弹计算详情" },
      },
      {
        name: "penetrateCalculate",
        path: "/penetrateCalculate/:project_id",
        component: () =>
          import("@/views/calculationDetails/penetrateCalculate"),
        meta: { title: "砂浆贯入计算详情" },
      },
      {
        name: "concreteCalculate",
        path: "/concreteCalculate/:project_id",
        component: () => import("@/views/calculationDetails/concreteCalculate"),
        meta: { title: "砼回弹计算详情" },
      },
    ],
  },
];

const createRouter = () =>
  new Router({
    mode: "hash",
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;
